module.exports = __webpack_public_path__ + "media/images/flags/ID-3f38233dfe7cc6fb8ddef8d130d89a36.svg";